import React, { PureComponent } from 'react'
import PageHeaderWrapper from '../../../../components/PageHeaderWrapper'
import GetAllFormFields from '../../../../components/_utils/formUtils'

// import {FormUtils as GetAllFormFields, TableComp} from 'sz-react-utils'
import { Button, Card, Col, Form, notification, Row, Select, Spin } from 'antd'
import _ from 'lodash'
import { goBack } from 'connected-react-router'
import { hideLoader, showLoader } from '../../../../modules/actions'
import Request, { API_URL, LAPI_URL } from '../../../../request'
import { connect } from 'react-redux'
import styles from './styles.less'
import moment from 'moment'


const Option = Select.Option


@Form.create()
class UpdateGenerateInvoice extends PureComponent {

    constructor(props) {
        super(props)
        this.state = {
            invoiceDates: [],
            commissionValue: 0,
            notificationMessage: false,
            loader: true
        }

    }

    handleSubmit = e => {
        const { dispatch, form } = this.props
        e.preventDefault()

        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let { invoiceDates, info, dueInvoiceId } = this.state
                let { feedBack } = this.props

                let values = _.clone(valData)
                dispatch(showLoader())


                valData._id = this.state.inquiryId
                valData.dueInvoiceId = dueInvoiceId
                // valData.nextInvoiceGenerationDates = invoiceDates


                let x = await Request.updateInvoice(valData)

                dispatch(hideLoader())
                if (!x.error) {

                    notification.success({
                        message: 'Success',
                        description: x.msg
                    })

                    if (feedBack) {
                        feedBack(x.doc)
                    } else {
                        dispatch(goBack())
                    }

                    this.props.form.resetFields()
                    this.props.form.setFieldsValue({ commission: this.state.commissionValue })
                } else {
                    notification.error({
                        message: 'Error Saving',
                        description: x.msg
                    })
                }
            }
        })
    }
    setFormValues = async inquiryId => {
        const { form } = this.props
        try {
            let { invoiceId, commissionValue, dueInvoiceId } = this.state
            this.setState({ screenLoad: true })

            let { doc } = await Request.getInquiry(inquiryId)
            this.setState({ screenLoad: false })
            if (doc) {

                let found = _.find(doc && doc.dueInvoices, (item) => {
                    return item._id == dueInvoiceId
                })
                if (found) {
                    form.setFieldsValue({
                        commission: found.commission,
                        dueDate: moment(found.dueDate),
                        tutionFee: found.tutionFee,
                        uploadInvoice: found.uploadInvoice,
                        invoiceRefNo: found.invoiceRefNo,
                        commissionAmount: Math.ceil((found.tutionFee * found.commission) / 100)
                    })
                }

                this.setState({
                    info: doc,
                    visaDesk: doc.visaDesk,
                    claimDesk: doc.claimDesk,
                    loading: false,
                    loader: false
                })
            } else {
                this.setState({ loader: false })
            }

        } catch (e) {
            console.log(e)
        }
    }


    async componentDidMount() {
        const { dispatch } = this.props

        let searchParams = new URLSearchParams(this.props.search)
        let inquiryId = searchParams.get('id')
        let dueInvoiceId = searchParams.get('dueInvoiceId')
        let invoiceId = searchParams.get('invoiceId')
        let { inquiryId1, dueInvoiceId1 } = this.props
        if (inquiryId1 && dueInvoiceId1) {
            inquiryId = inquiryId1
            dueInvoiceId = dueInvoiceId1
        }

        let { doc } = await Request.getInquiry(inquiryId)

        console.log('didmounrrrrrrr')
        let found = _.find(doc && doc.dueInvoices, (item) => {
            return item._id == dueInvoiceId
        })
        if (found) {
            this.setState({ singleDueInvoice: found })
        }

        let channelPartnerId = doc && doc.visaDesk && doc.visaDesk.channelPartnerId
        let universityId = doc && doc.visaDesk && doc.visaDesk.selectedCourse && doc.visaDesk.selectedCourse.universityId

        if (doc && doc.leadSource == 'Channel Partner') {
            let { doc: channelPartner } = await Request.getPartner(channelPartnerId)
            this.setState({
                commissionValue: channelPartner && channelPartner.commission,
                channelPartnerName: channelPartner && channelPartner.channelPartnerName
            })
        } else {
            let { doc: universityData } = await Request.getUniversity(universityId)
            this.setState({ commissionValue: universityData && universityData.commission })

        }


        if (inquiryId) {
            this.setState({
                inquiryId: inquiryId,
                dueInvoiceId: dueInvoiceId
            })
            this.setFormValues(inquiryId)
        }


    }

    render() {
        const { dispatch, form } = this.props
        const { info, visaDesk, claimDesk, channelPartnerName, loading, singleDueInvoice } = this.state
        const inputSchema = {
            fields: [
                {
                    label: 'Invoice Ref No',
                    key: 'invoiceRefNo',
                    required: true

                },
                {
                    label: 'Invoice Due Date',
                    key: 'dueDate',
                    type: 'date',
                    required: true

                },
                {
                    label: 'Tution Fee',
                    key: 'tutionFee',
                    type: 'number',
                    required: true,
                    onChange: v => {

                        let commissionValue = form.getFieldValue('commission')
                        this.props.form.setFieldsValue({
                            commissionAmount: Math.ceil((v * commissionValue) / 100),
                            tutionFee: v
                        })
                    }

                },
                {
                    label: 'Commission ', key: 'commission', type: 'number',
                    rightComp: <span style={{ marginLeft: '5px' }}>%</span>,
                    required: true,
                    onChange: v => {
                        let feeValue = form.getFieldValue('tutionFee')
                        this.props.form.setFieldsValue({
                            commissionAmount: Math.ceil((feeValue * v) / 100),
                            commission: v
                        })
                    }

                },
                {
                    label: 'Invoice Amount ', key: 'commissionAmount', type: 'number',
                    disabled: true
                },


                {
                    label: 'Upload Invoice',
                    key: 'uploadInvoice',
                    type: 'file'
                }
            ]
        }


        const { submitting } = this.props
        const {
            form: { getFieldDecorator, getFieldValue }
        } = this.props


        return (
            <PageHeaderWrapper title={'Update Invoice'}>
                <Spin spinning={this.state.loader}>
                    <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                        <Card bordered={true}>

                            <Row>
                                <Col span={8}>
                                    <table className={styles.dataTable}>
                                        <tbody>
                                            <tr>
                                                <td>Student Name</td>
                                                <td>{info && info.studentName}</td>
                                            </tr>
                                            <tr>
                                                <td>Invoice No.</td>
                                                <td>{singleDueInvoice && singleDueInvoice.invoiceNo}</td>

                                            </tr>
                                            <tr>
                                                <td>Invoice Date</td>
                                                <td>{singleDueInvoice && singleDueInvoice.invoiceDate ? moment(singleDueInvoice.invoiceDate).format('DD-MM-YYYY') : ''}</td>
                                            </tr>

                                            <tr>
                                                <td>Mobile</td>
                                                <td>{info && info.mobile}</td>
                                            </tr>
                                            <tr>
                                                <td>DOB</td>
                                                <td>{info && info.dateOfBirth ? moment(info.dateOfBirth).format('DD-MM-YYYY') : ''}</td>
                                            </tr>
                                            <tr>
                                                <td>Branch</td>
                                                <td>{info && info.studentBranchId && info.studentBranchId.branchName}</td>
                                            </tr>
                                            <tr>
                                                <td>Current Desk</td>
                                                <td>{info && info.atLevel}</td>
                                            </tr>
                                            <tr>
                                                <td>Visa Approval Date</td>
                                                <td>{info && info.visaDesk && info.visaDesk.visaApprovalDate ? moment(info.visaDesk.visaApprovalDate).format('DD-MM-YYYY') : ''}</td>
                                            </tr>
                                            <tr>
                                                <td>Passport No.</td>
                                                <td>{visaDesk && visaDesk.passportNo}</td>
                                            </tr>
                                            <tr>
                                                <td>Invoicee</td>
                                                <td>
                                                    <div>{info && info.leadSource == 'Channel Partner' ? info.leadSource : 'University'}</div>
                                                    <small>{info && info.leadSource == 'Channel Partner' ? channelPartnerName : ''}</small>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Course Start Date</td>

                                                <td>{visaDesk && visaDesk.courseStartDate ? moment(visaDesk.courseStartDate).format('DD-MM-YYYY') : ''}</td>
                                            </tr>
                                            <tr>
                                                <td>University Name</td>
                                                <td>{visaDesk && visaDesk.selectedCourse && visaDesk.selectedCourse.universityInstitutionName}</td>
                                            </tr>
                                            <tr>
                                                <td>Course Name</td>
                                                <td>{visaDesk && visaDesk.selectedCourse && visaDesk.selectedCourse.courseName}</td>
                                            </tr>
                                            <tr>
                                                <td>Student Status</td>
                                                <td>{info && info.studentStatus}</td>
                                            </tr>
                                            <tr>
                                                <td>Invoice Status</td>
                                                <td>{info && info.invoiceStatus}</td>
                                            </tr>
                                        </tbody>

                                    </table>

                                </Col>
                                <Col span={16}>
                                    <GetAllFormFields
                                        inputSchema={inputSchema}
                                        loading={this.props.loading}
                                        apiurl={LAPI_URL}
                                        getFieldDecorator={getFieldDecorator}
                                        formItemLayout={{
                                            labelCol: { span: 10 },
                                            wrapperCol: { span: 12 }
                                        }}

                                    />


                                    <Row>


                                        <Col style={{ textAlign: 'Center' }}>

                                            <Button
                                                htmlType="submit"
                                                style={{
                                                    marginTop: 10,
                                                    backgroundColor: '#85CF4A',
                                                    border: '1px solid #85CF4A',
                                                    color: 'white'
                                                }}
                                                loading={this.props.loading}>
                                                Update Invoice
                                            </Button></Col>
                                    </Row>

                                </Col>
                            </Row>
                        </Card>


                    </Form>
                </Spin>


            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    allChannelPartners: global.allChannelPartners,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UpdateGenerateInvoice)


